<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>

        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                </div>
            </div>
            <div class="col-md-6" />
            <div class="col-md-2">
                <b-button id="create" v-b-modal.form-modal variant="primary" class="btn-block" @click="cleanUpForm()"
                    v-if="userData.role == 'admin'">
                    Create
                </b-button>
            </div>
        </div>

        <b-card-code no-body>
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Slug</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="item, index in result.items" :key="index">
                                <td>{{ item.name || '-' }}</td>
                                <td>{{ item.slug || '-' }}</td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example"
                                        v-if="userData.role == 'admin'">

                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="editItem(item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="delete" variant="danger" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                        <!-- <pagination :data="result" :limit="4" align="right" @pagination-change-page="getData" /> -->
                    </div>
                </div>
            </div>
        </b-card-code>

        <!-- Add/Edit Modal -->
        <b-modal id="form-modal" size="lg" :title="editId != null ? 'Edit Category' : 'Add Category'">

            <div class="form-group">
                <FormInput id="name" label="Name" v-model="formPayload.name" :validation="validations.name"
                    :placeholder="'Category name'" :required="true" :type="'text'" :modelValue="formPayload.name" />
            </div>
            <div class="form-group" v-if="editId">
                <FormInput id="slug" label="Slug" v-model="formPayload.slug" :validation="validations.slug"
                    :placeholder="'Category slug'" :required="true" :type="'text'" :modelValue="formPayload.slug" />
            </div>

            <template #modal-footer="{}">
                <div v-if="isLoading" class="mb-1">
                    <b-spinner class="mb-2" variant="primary" /><br>
                </div>
                <b-button v-if="editId == null" variant="success" :disabled="isLoading" @click="createItem()">
                    Save Item
                </b-button>
                <b-button v-else variant="success" :disabled="isLoading" @click="updateItem()">
                    Save Item
                </b-button>
            </template>
        </b-modal>
        <!-- Add/Edit Modal -->

    </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BSpinner, BPagination, BFormInput,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import FormInput from '@/components/FormInput.vue'

export default {
    title() {
        return 'Category Management'
    },
    components: {
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BSpinner,
        BPagination,
        BFormInput,
        FormInput,
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    mixins: [heightTransition],
    watch: {
        filter: {
            handler: _.debounce(function () {
                this.getData()
            }, 300),
            deep: true,
        },
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            options: [
                { value: null, text: 'Please select an option' },
                { value: 'owner', text: 'Owner' },
                { value: 'editor', text: 'Editor' },
                { value: 'contributor', text: 'Contributor' },
            ],

            result: Object,
            isLoading: false,
            formPayload: {
                name: '',
            },
            editId: null,
            filter: {
                search: '',
            },
            validations: {},
        }
    },
    mounted() {
        this.getData()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                name: '',
                null: null
            }
        },
        getData(page = 1) {
            this.isLoading = true
            this.currentPage = page
            const queryParams = this.filter
            queryParams.page = this.currentPage

            this.$http.get('/admin/post-categories', {
                params: queryParams,
            })
                .then(response => {
                    const data = response.data.data;
                    this.result = data;
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                })
        },
        createItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.post('/admin/post-categories', form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Category successfully created')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.patch(`/admin/post-categories/${this.editId}`, form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Category successfully updated!')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    form.append(key, this.formPayload[key])
                }
            }

            return form
        },
        editItem(item) {
            this.editId = item._id
            this.formPayload = {
                name: item.name,
                slug: item.slug,
            }

            this.$bvModal.show('form-modal')
        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete this category?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/post-categories/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Category successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            const messages = error.response.data.meta.messages
                            // this.validations = validations
                            if (validations) {
                                for (const key in validations) {
                                    if (validations.hasOwnProperty(key)) {
                                        errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                    }
                                }
                            }
                            if (messages) {
                                errorNotification(this, 'Oops!', messages)
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
